import React from "react";
import Icon from "../../shared/components/icon";
import useQuery from "../../shared/utils/queryParams";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import styled from "styled-components";
import Layout from "../../shared/components/layout";

const ControlsContainer = styled.div`
  width: 100%;
`;

const ErrorContainer = styled.div`
  margin-top: 15px;
  min-height: 25px;
  margin-bottom: 10px;
`;

const ErrorMsgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HealthcareAddress = styled.address`
  margin: 2rem 3rem;
`;

const BodyContent = styled.div`
  /* a little above footer min-height */
  padding-bottom: 175px;
`;

const RequestText = styled.div`
  font-family: gotham-700;
  font-size: 18px;
  margin-top: 16px;
  margin-bottom: 5px;
`;

const Terms = styled.div`
  margin-top: 20px;

  h4 {
    font-size: 18px;
  }
`;

const FooterContent = styled.div`
  border-top: 2px solid #e4e4e4;
  margin: 0 auto;
  padding: 20px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  min-height: 150px;
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
`;

function UserConsent() {
  const { register, handleSubmit, errors } = useForm();

  const query = useQuery();
  const nonce = query.get("nonce");
  const state = query.get("state");
  const client_id = query.get("client_id");
  const client_name = query.get("client_name");
  const redirect_uri = query.get("redirect_uri");
  const enterprise_id = query.get("enterprise_id");

  const onSubmit = () => {
    const termsForm = document.getElementById("terms-form");
    termsForm.action = process.env.REACT_APP_AUTH_URL;
    termsForm.submit();
  };

  return (
    <Layout>
      <form id="terms-form" method="post" onSubmit={handleSubmit(onSubmit)}>
        <input
          type="hidden"
          id="login-form-type"
          name="login-form-type"
          value="pwd"
        ></input>
        <input type="hidden" name="nonce" value={nonce} />
        <input type="hidden" name="state" value={state} />
        <input type="hidden" name="client_id" value={client_id} />
        <input type="hidden" name="redirect_uri" value={redirect_uri} />
        <input type="hidden" name="enterprise_id" value={enterprise_id} />

        <BodyContent>
          <RequestText>
            Authorize Cigna to share Protected Health Information (PHI){" "}
            {client_name}
          </RequestText>

          <Terms>
            <p>
              I hereby authorize Cigna Healthcare, its agents or subsidiaries,
              at my request, to disclose my Protected Health Information (PHI)
              to the third party application specified through this portal for a
              period of three (3) months.
            </p>
            <p>
              I understand that this PHI may include past or current information
              about my medical conditions and treatments, laboratory tests and
              results, medications and therapies, surgeries, hospitalizations,
              mental health, sexually transmitted disease, alcohol/substance
              use, and/or HIV/AIDS (Human Immunodeficiency Virus/Acquired Immune
              Deficiency Syndrome) history, if any, and related conditions.
            </p>
            <p>
              <span className="bold">Please note:</span>
              <br />
              Information disclosed based on this authorization may be subject
              to re-disclosure by the recipient and may no longer be protected
              by federal privacy regulations.
            </p>
            <p>
              You may revoke this request by contacting the number on the back
              of your ID card.
            </p>
            <p>
              By selecting you are agreeing that you authorize Cigna Healthcare,
              its agents or subsidiaries, to disclose PHI to the third party
              application <u>named above</u>, and agree that Cigna is not
              responsible for the use, disclosure or security of the PHI once it
              has been transferred to the third party application.
            </p>
          </Terms>
        </BodyContent>

        <FooterContent>
          <label className="checkbox-container" htmlFor="termsAccept">
            I agree to the terms and conditions
            <input
              type="checkbox"
              id="termsAccept"
              name="termsAccept"
              className="cigna-checkbox"
              ref={register({ required: true })}
            />
            <span className="checkmark"></span>
          </label>

          <ControlsContainer>
            <button type="submit" className="btn btn-primary btn-lg bold">
              Share Health Information
            </button>
          </ControlsContainer>

          <ErrorContainer>
            <ErrorMessage
              errors={errors}
              name="termsAccept"
              render={() => (
                <ErrorMsgContainer className="validation-error-msg">
                  <Icon type="red-alert" size={17} /> &nbsp; Accept the terms
                  before continuing
                </ErrorMsgContainer>
              )}
            />
          </ErrorContainer>
        </FooterContent>
      </form>
    </Layout>
  );
}

export default UserConsent;
